import { render, staticRenderFns } from "./Engagements.vue?vue&type=template&id=5f4fac88"
import script from "./Engagements.vue?vue&type=script&lang=js"
export * from "./Engagements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports